<template>
  <div class="container-order-info">
    <h4 class="container-order-info__main-title">{{$t('order_information')}}</h4>

    <template v-if="! withDriver">
      <DriverFalseWrapperComponent :order-data="orderData"></DriverFalseWrapperComponent>
    </template>
    <template v-else>
      <DriverTrueWrapperComponent :order-data="orderData"></DriverTrueWrapperComponent>
    </template>

  </div>
</template>

<script>
import './rentOrderInfo.scss';
import {defineComponent} from "vue";
// @ts-ignore
import DriverFalseWrapperComponent from "./driverFalseWrapper/DriverFalseWrapperComponent.vue";
import DriverTrueWrapperComponent from "./driverTrueWrapper/DriverTrueWrapperComponent";

export default defineComponent({
  name: 'RentOrderInfoComponent',
  components: {
    DriverTrueWrapperComponent,
    DriverFalseWrapperComponent
  },
  props: {
    orderData: {
      type: Object,
    },
    withDriver: {
      type: Boolean,
    }

  },
})

</script>

<style>

</style>